import { atomWithStorage } from "jotai/utils";

export const selectedOrganisationIdAtom = atomWithStorage<string | null>(
  "selectedOrganisationId",
  null
);
